import { Colors, Metrics } from "../../resources";
import { DensityAccount, Headers, SIconType } from "../../types";
import { StyleSheet, View } from "react-native";
import { useSettings, useUser } from "../../hooks";

import { Navbar } from "@density/ui";
import React from "react";
import SIconLink from "../atoms/SIconLink";
import { stringToBoolean } from "@densityco/lib-common-helpers";

interface IProps {
  headers: Headers;
  impersonate: boolean | undefined;
  onPressImpersonate: (impersonate: boolean) => void;
}

const STitleBar: React.FC<IProps> = ({
  headers,
  impersonate,
  onPressImpersonate,
}) => {
  const { settings } = useSettings();
  const { user } = useUser();

  const onImpersonate = () => {
    onPressImpersonate(true);
  };

  const can = (permission: string, permissions: string[] | undefined) => {
    if (permissions === undefined) {
      return false;
    }

    return permissions.find((element) => element === permission) !== undefined;
  };

  const showOpenArea = stringToBoolean(
    user?.organization?.settings?.open_area_enabled,
    true
  );

  const showAdminMenu =
    can("owner_user_manage", user?.permissions) ||
    can("admin_user_manage", user?.permissions) ||
    can("readonly_user_manage", user?.permissions);

  const showDevTools = can("developer_tools_manage", user?.permissions);
  const showOrganizationSettings = can(
    "global_settings_manage",
    user?.permissions
  );

  const showSensorList = can("sensors_list", user?.permissions);

  return (
    <View style={styles.container}>
      <Navbar
        path={window.location.href}
        showPortfolio={true}
        showOpenArea={showOpenArea}
        showAdminMenu={showAdminMenu}
        showDevTools={showDevTools}
        showOrganizationSettings={showOrganizationSettings}
        showSensorList={showSensorList}
        impersonate={
          impersonate ? (
            <>
              <SIconLink
                type={SIconType.Impersonate}
                title={
                  settings?.impersonate
                    ? settings?.impersonate[0].toUpperCase() +
                      settings?.impersonate.substring(1)
                    : DensityAccount.DEMO
                }
                onPress={onImpersonate}
              />
            </>
          ) : null
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    height: Metrics.menuRegularHeight,
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: Colors.grey200,
    borderBottomWidth: 0.5,
    paddingHorizontal: Metrics.padding16,
    backgroundColor: Colors.white,
    zIndex: 5,
  },
  rightContainer: {
    flexDirection: "row",
  },
});

export default STitleBar;
